import React from 'react';
import AddIcon from '@mui/icons-material//Add';
import { Button } from '@mui/material';
import { AddActionButtonProps } from './AddActionButton.props';

const AddActionButton = ({ onClickHandler, disabled, text }: AddActionButtonProps) => (
  <div>
    <Button
      variant="outlined"
      startIcon={<AddIcon />}
      onClick={onClickHandler}
      disabled={disabled}
      className="btn-table-aligned">
      {text}
    </Button>
  </div>
);

export default React.memo(AddActionButton);
